import React, { useEffect, useState } from "react";
import Div from "../../../../widget/common/ui/Div";
import Center from "../../../../widget/common/ui/Center";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import AppConfigService from "../../../../service/app_config/AppConfigService";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { textCase } from "../../../../service/ui/UI";
import { ButtonSingle } from "../../../../widget/common/form/Button";
import CacheStorage from "../../../../service/storage/CacheStorage";
import StorageKeys from "../../../../const/StorageKeys";
import { useDispatch } from "react-redux";
import {
  addModal,
  removeAllModal,
} from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";
import { setBranchListScreenName } from "../../../../libraries/state_reducers/branch/BranchListReducer";
import { routeName as routeNameSignupVerification } from "../account_verification/SignupAccountVerificationScreen";

const SignupWelcomeAlert = () => {
  const type: number = ResponsiveDeviceType();
  const dispatch = useDispatch();

  const [name, setName] = useState<string>("");

  const setupName = () => {
    const nameSession: string = CacheStorage.getValue(StorageKeys.name);
    setName(nameSession);
  };

  const onClickOk = () => {
    dispatch(
      setBranchListScreenName({
        screenName: routeNameSignupVerification,
      })
    );

    //if (type === 3) {
    dispatch(removeAllModal());
    dispatch(
      addModal({
        id: ModalKeys.list_choose_branch,
        title: AppTranslation.text("choose_preferred_branch"),
        screenMobileView: type !== 3,
        static: true,
      })
    );
    // } else {
    // }
  };

  useEffect(() => {
    setupName();
  }, []);

  return (
    <Div className="pt-4">
      <Center>
        <LogoRound
          url={AppConfigService.get("company_logo")}
          name={AppConfigService.get("company_name")}
          className="login-logo"
          size={type === 1 ? 100 : 150}
        />
      </Center>
      <SpacingHeight value={type === 1 ? 27 : type === 2 ? 20 : 37} />
      <TextBlock
        center={true}
        fontSize="16_17"
        fontName="bold"
        textColor="black"
        maxLine={2}
      >
        {textCase(`${AppTranslation.text("hi")} ${name}!`)}
      </TextBlock>
      <SpacingHeight value={type === 3 ? 20 : 1} />
      <Div className="font-size-16_17 color-black text-center pb-5">
        <Div className="font-gotham-bold pb-3">
          {AppTranslation.text("welcome_to_communicatr")}
        </Div>
        <Div>
          {AppTranslation.text("you_have_successfully_created_profile")}
        </Div>
      </Div>

      <ButtonSingle handleClick={() => onClickOk()}>
        {AppTranslation.text("ok")}
      </ButtonSingle>
    </Div>
  );
};

export default SignupWelcomeAlert;
